import { render, staticRenderFns } from "./giftcard-slide.vue?vue&type=template&id=8135f3d8&scoped=true&"
import script from "./giftcard-slide.vue?vue&type=script&lang=js&"
export * from "./giftcard-slide.vue?vue&type=script&lang=js&"
import style0 from "./giftcard-slide.vue?vue&type=style&index=0&id=8135f3d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8135f3d8",
  null
  
)

export default component.exports